const mod = require('onyx-root/react-dom')

module.exports = mod
